import Base, { baseInit } from './base';
import { CREATIVE_FILE_SIZE_ALLOWED, BYTES_IN_KB, FILE_TYPE_UPLOAD } from '../constant';

import commonHelper from '../helpers/common';

class File extends Base {
  _uuid = null; // String - internal field used for referencing creatives
  path = null; // string
  id = null; // Integer
  size = null;
  name = null;
  type = FILE_TYPE_UPLOAD; // default value upload

  constructor(data) {
    super(data);
    baseInit(this, data, true);
  }

  isValid() {
    if (!commonHelper.isNil(this.name) && commonHelper.isImageType(this.name)) {
      return Math.ceil(this.size / BYTES_IN_KB) <= CREATIVE_FILE_SIZE_ALLOWED;
    }
    return true;
  }
}

export { File };
